<template>
   <timeline-element-container secondary blue :key="`${reportOfSickness.id}-${uwvDecision.id}-tec`">
      <div slot='left' class='date-container'>
        <p>{{ formatDate(uwvDecision.startDate) }}</p>
        <p class='label'>{{ 'general.report-on' | translate }}</p>
        <p>{{ formatDate(uwvDecision.reportDate) }}</p>
      </div>

      <div slot='right' class='report-detail'>
        <div class='bordered-container-uwv-header'>
          <uwv-logo class='uwv-icon' />
          <p>UWV Beslissing</p>
        </div>

        <div class='element-details'>
          <table class='confirmation-table confirmation-table-adjust-padding mt-2 mb-2'>
            <tr>
              <td>{{ 'uwv-decision.fields.decision-type' | translate }}</td>
              <td>{{ 'uwv-decision.types.' + uwvDecision.decisionType | translate }}</td>
            </tr>
            <tr>
              <td>{{ 'uwv-decision.fields.disability-rate' | translate }}</td>
              <td>{{ uwvDecision.disabilityRate }}%</td>
            </tr>
            <tr v-if="isOpen">
              <td>{{ 'uwv-decision.fields.report-date' | translate }}</td>
              <td>{{ formatDate(uwvDecision.reportDate) }}</td>
            </tr>
            <tr v-if="isOpen">
              <td>{{ 'uwv-decision.fields.decision-date' | translate }}</td>
              <td>{{ formatDate(uwvDecision.decisionDate) }}</td>
            </tr>
            <tr v-if="isOpen">
              <td>{{ 'uwv-decision.fields.start-date' | translate }}</td>
              <td>{{ formatDate(uwvDecision.startDate) }}</td>
            </tr>
            <tr v-if="isOpen">
              <td>{{ 'uwv-decision.fields.benefit-end-date' | translate }}</td>
              <td>{{ uwvDecision.benefitEndDate ? formatDate(uwvDecision.benefitEndDate) : 'Onbepaald' }}</td>
            </tr>
            <tr v-if="isOpen">
              <td>{{ 'uwv-decision.fields.wia-daily-wage' | translate }}</td>
              <td>{{ formatCurrency(uwvDecision.wiaDailyWage) }}</td>
            </tr>
            <tr v-if="isOpen">
              <td>{{ 'uwv-decision.fields.wia-monthly-wage' | translate }}</td>
              <td>{{ formatCurrency(uwvDecision.wiaMonthlyWage) }}</td>
            </tr>
            <tr v-if="isOpen">
              <td>{{ 'uwv-decision.fields.income-from-work' | translate }}</td>
              <td>{{ formatCurrency(uwvDecision.incomeFromWork) }}</td>
            </tr>
            <!-- <tr>
              <td>{{ 'uwv-decision.fields.status' | translate }}</td>
              <td><report-of-sickness-status :status="uwvDecision.status" /></td>
            </tr> -->
          </table>
          <div class='show-more-rule' />
          <div class='show-more-button' @click="isOpen = !isOpen">
            <div class='fl'>
              <p v-if="!isOpen">Meer informatie laten zien</p>
              <p v-else>Minder informatie laten zien</p>
              <v-icon v-if="!isOpen">keyboard_arrow_down</v-icon>
              <v-icon v-else>keyboard_arrow_up</v-icon>
            </div>
          </div>
          <div style="clear: both" />

        </div>
      </div>
    </timeline-element-container>
</template>

<script>
import Helpers from '@/shared/helpers/functions';

import UwvLogo from '@aevitae/aevitaeui/0_atoms/icons/UwvLogo.vue';
import TimelineElementContainer from '@aevitae/aevitaeui/0_atoms/containers/TimelineElementContainer.vue';

export default {
  name: 'UwvDecisionTimelineElement',
  components: {
    TimelineElementContainer,
    UwvLogo
  },
  props: {
    reportOfSickness: Object,
    uwvDecision: Object,
    employee: Object
  },
  data () {
    return {
      isOpen: false
    };
  },
  methods: {
    formatDate: (date) => Helpers.Dates.formatDate(date),
    formatCurrency: (v) => Helpers.Currency.formatCurrency(v)
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/stylesheets/variables.scss';

h2 {
  color: $primary;
}

h5 {
  font-size: 1.4em;
  letter-spacing: -.1px;
  font-family: 'Source Sans Pro';
}

h6 {
  position: relative;
  top: 1px;
}

.element-details {
  padding: 0px 15px;
}

.disability-rate-difference {
  position: relative;
  top: 2px;
  margin-right: 25px;
}

.confirmation-table {
  tr {
    &:first-child {
      td {
        border-top: 0;
        padding-top: 0;
      }
    }
    &:last-child {
      td {
        border-bottom: 0;
        padding-bottom: 0;
      }
    }
  }
}

.report-detail {
  position: relative;
  top: -10px;
  margin-bottom: 30px;
}

.date-container {
  :nth-child(1) {
    font-weight: 600;
    color: $primary;
    font-size: 1.1em;
    margin-bottom: 10px;

    &.recovery { color: $positive; }
  }
}

.recovery {
  color: $positive;
}

.action-list {
  background-color: $secondary-lighten-3;
  padding: 30px;

  h3 {
    font-size: 1em;
    color: $secondary;
    margin-bottom: 20px;
  }

  .item {
    background-color: white;
    padding: 5px;

    p {
      color: $primary;
    }
  }
}

.bordered-container-uwv-header {
  padding: $base-padding;
  background-color:#d6effd;
  color: white;
  border: 1px solid #d6effd;
  font-weight: 600;
  border-radius: $border-radius;
  position: relative;
  overflow: hidden;
  margin-bottom: 20px;

  p {
    z-index: 1 !important;
    color: #1f8cc5;
    position: relative;
  }
}

.uwv-icon {
  fill: #c6e6f8;
  top: -16px;
  position: absolute;
  height: 189%;
  left: 6px;
}

.show-more-button {
  background-color: $gray-lighten-2;
  padding: 8px 12px 8px 19px;
  color: $primary;
  cursor: pointer;
  border-bottom-left-radius: $border-radius;
  border-bottom-right-radius: $border-radius;
  position: relative;
  display: block;
  margin: 0 auto;
  width: fit-content;
  float: right;

  p {
    color: $primary;
  }

  .v-icon {
    color: $primary;
    position: relative;
    top: 1px;
    margin-left: 5px;
  }
}

.show-more-rule {
  height: 1px;
  display: block;
  width: 100%;
  background-color: darken($gray-lighten-2, 1%);
}

</style>
